const getFileExtension = fileName => fileName.split('.').pop();
const getTypePrefix = fileType => fileType.split('/').shift();
const isImage = fileType => getTypePrefix(fileType) === 'image';
const isSameType = (typeA, typeB) => getTypePrefix(typeA) === getTypePrefix(typeB);

export default {
  getFileExtension,
  getTypePrefix,
  isImage,
  isSameType,
};
